export enum RouteNames {
  WISH_WIZARD = 'wish-wizard',
  WISH_PREVIEW = 'wish-preview',
  WISH_SNEAK = 'wish-sneak',
  UNAVAILABLE = 'unavailable',
}
